var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[
    'btn btn-sm btn-outline-secondary',
    !_vm.getBarcodeUrl ? 'btn-disabled disabled' : '' ],attrs:{"href":_vm.getBarcodeUrl,"target":"_blank"}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" Barkod Yazdır")])}
var staticRenderFns = []

export { render, staticRenderFns }